export const lightAccentInfo70 = "#3F698F";
export const lightBlueLiveBackground = "rgba(63, 105, 143, 0.1)";
export const lightAccentSuccess70 = "#458540";
export const lightGreenBackground = "#def7dc66";
export const lightGreenBackgroundSolid = "#def7dc";
export const lightRedBackground = "#f0d5d566";
export const lightRedBackgroundSolid = "#f0d5d5";
export const lightTextSubheading = "#626364";
export const lightSurface0 = "#EDEDEF";
export const lightTextPlaceholder = "#8B8C8E";
export const lightProducing = "#39B54A";
export const lightUnknown = "#FF3333";
export const lightSurface2 = "#F6F6F8";
export const lightBorder1 = "#DADBDE";
export const lightNeutral50 = "#C7C8CB";
export const summarySectionBottomBorder = "#AD8863";
export const summarySectionBottomBackground = "#F9E9D9";
export const lightAccentInfo20 = "#DDEBFA";
export const lightAccentInfo50 = "#7EA4C7";
export const lightAccentSuccess50 = "#7DB877";
export const lightAccentFail50 = "#E89090";
